/**
 * Shared paid-training removal helpers for Admin and Company portal event forms.
 * Mirrors legacy Admin `PaidTrainingFields` toggle/modal behaviour.
 */

export const PAID_TRAINING_MEANINGFUL_DATA_FIELDS = [
  "name",
  "payroll_amount",
  "description",
  "number_of_days",
  "starts_at",
  "ends_at",
  "before_check_in_margin",
  "after_check_in_margin",
  "before_check_out_margin",
  "after_check_out_margin",
  "location_address",
  "location_radius",
  "lat",
  "lng",
];

/**
 * Toggle shows "on" when training exists and is not marked for deletion.
 * @param {object|null|undefined} trainingAttributes
 * @returns {boolean}
 */
export const isPaidTrainingToggleOn = (trainingAttributes) =>
  Boolean(trainingAttributes && trainingAttributes._destroy !== true);

/**
 * Whether turning off paid training should require confirmation (edit + real data).
 * @param {object|null|undefined} trainingAttributes
 * @returns {boolean}
 */
export const hasMeaningfulPaidTrainingData = (trainingAttributes) => {
  if (!trainingAttributes || trainingAttributes._destroy === true) {
    return false;
  }
  const hasPersistedId =
    trainingAttributes.id != null && trainingAttributes.id !== "";
  if (hasPersistedId) return true;
  return PAID_TRAINING_MEANINGFUL_DATA_FIELDS.some((field) =>
    String(trainingAttributes[field] ?? "").trim()
  );
};
